import React from 'react';

import 'components/pages/UserPage/links/edit/LinkEdit.scss';

export const LinkEdit = () => {
    return <div>Link EDIT</div>;
};

export default LinkEdit;
